import { render, staticRenderFns } from "./RolePermissionsEditForm.vue?vue&type=template&id=2b97c5aa&scoped=true&"
import script from "./RolePermissionsEditForm.vue?vue&type=script&lang=ts&"
export * from "./RolePermissionsEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./RolePermissionsEditForm.vue?vue&type=style&index=0&id=2b97c5aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b97c5aa",
  null
  
)

export default component.exports